import { TbShirtSport } from "react-icons/tb";
import { HiOutlineTicket } from "react-icons/hi";
import { MdOutlineEventSeat, MdOutlinedFlag } from "react-icons/md";

export const howItWorks = [
  {
    icon: <MdOutlinedFlag />,
    title: "Choose Your Events",
    description: "Select the events you wish to attend.",
  },
  {
    icon: <MdOutlineEventSeat />,
    title: "Login to Account Manager.",
    description:
      "Click Continue and connect your Live Nation account using our secure login.",
  },
  {
    icon: <TbShirtSport />,
    title: "Select Your Seats",
    description: "Select the seats you wish to purchase for each event.",
  },
  {
    icon: <HiOutlineTicket />,
    title: "Get Your Tickets",
    description:
      "Tickets will be available in your Account Manager account within 24 hours of purchase. Reach out to Live Fan Support for any questions.",
  },
];

export const faqs = [
  {
    title: "How does the Live Nation work?",
    description:
      "The Live Nation allows fans to select any seat to select events hosted by the Live Nation. Simply log into your Live Nation Account Manager and select events.",
  },
  {
    title: "Do I have to select all my events now?",
    description: "Yes, you must select all events at the time of purchase.",
  },
  {
    title: "Can I choose seats throughout the venue?",
    description: "Yes, you can choose from all current available inventory.",
  },
  {
    title: "Where are event tickets delivered?",
    description:
      "Tickets are delivered directly within your Live Nation Account Manager Account.",
  },
];
